import type { Expense, ExpenseCategory, ExpenseStatus } from '@/lib/types';

export interface ExpenseSearchFilters {
  status: string;
  category: string;
  q: string;
}

export function normalizeExpenseFilters(searchParams: URLSearchParams): ExpenseSearchFilters {
  return {
    status: searchParams.get('status') || 'all',
    category: searchParams.get('category') || 'all',
    q: searchParams.get('q') || '',
  };
}

export function filterExpenses(expenses: Expense[], filters: ExpenseSearchFilters) {
  const query = filters.q.trim().toLowerCase();

  return expenses.filter((expense) => {
    if (filters.status !== 'all' && expense.status !== (filters.status as ExpenseStatus)) return false;
    if (filters.category !== 'all' && !expense.items.some((item) => item.category === (filters.category as ExpenseCategory))) return false;
    if (!query) return true;

    return Boolean(
      expense.store_name?.toLowerCase().includes(query) ||
        expense.notes?.toLowerCase().includes(query) ||
        expense.items.some((item) => item.name.toLowerCase().includes(query))
    );
  });
}

export function buildExpenseDetailTitle(expense: Expense | null) {
  return expense?.store_name || 'Expense';
}
